import { SxProps, Tab, Tabs as MuiTabs, TabsProps, Box } from '@mui/material';
import { QuoteType } from '@models/quotes';
import { PolicyType } from '@models/policy';
import { Chip } from '@components/chip';
import { tabsSx, miniTabsSx, headerTabsSx } from './Tabs.styles';
import { useTheme } from '@mui/material';

export interface TabOptions {
  value: number;
  label: string;
  quantity?: string | number;
  styles?: SxProps;
  searchParams?: string;
}
export interface PolicyTabOptions extends TabOptions {
  isActive?: PolicyType;
}
export interface QuoteTabOptions extends TabOptions {
  quoteType: QuoteType;
  queryParam: string;
  styles?: SxProps;
}

interface ITabsQuotes extends TabsProps {
  tabOptions?: PolicyTabOptions[] | QuoteTabOptions[];
  type?: 'mini' | 'miniShort' | 'header';
  children?: React.ReactNode;
  disableRipple?: boolean;
}

export const Tabs = ({ children, tabOptions, type, disableRipple, ...other }: ITabsQuotes) => {
  const theme = useTheme();
  return (
    <MuiTabs
      {...other}
      sx={[
        type === 'mini' || type === 'miniShort' ? miniTabsSx(theme) : type === 'header' ? headerTabsSx(theme) : tabsSx,
        type === 'miniShort' && {
          minHeight: '20px',
          marginBottom: '8px !important',
          '.MuiTab-root': {
            minHeight: '20px',
          },
        },
      ]}
    >
      {tabOptions &&
        tabOptions.map((tab) => (
          <Tab
            disableRipple={disableRipple}
            id={`tab${tab.value}`}
            aria-controls={`tabPanel${tab.value}`}
            value={tab.value}
            label={tab.label}
            key={tab.label}
            icon={
              tab.quantity ? (
                <Box>
                  <Chip variant='outlined' label={tab.quantity?.toString()} />
                </Box>
              ) : undefined
            }
            iconPosition='end'
            sx={tab.styles}
          />
        ))}
      {children}
    </MuiTabs>
  );
};
